package com.devi3east.bashbuddy.search.ui

import kotlinx.datetime.Instant

enum class SearchFilterType {
    EVENT_TITLE,
    ORGANIZATION,
    STATE,
    MONTH,
    DATE,
    DISTANCE
}

data class SearchFilters(
    val filterType: SearchFilterType = SearchFilterType.EVENT_TITLE,
    val event: String? = null,
    val organization: String? = null,
    val state: String? = null,
    val month: Int? = null,
    val date: Instant? = null,
    val distance: Int? = null
)